
import { useState, useEffect } from "react";
import { ContactsList } from "../ContactsList";
import { ContactViewModal } from "../ContactViewModal";
import { ContactEditModal } from "../ContactEditModal";
import { Contact } from "./types";
import { getSavedViewMode, saveViewMode } from "@/utils/viewMode";

interface ContactsContentProps {
  contacts: Contact[];
  loading: boolean;
  viewMode: 'list' | 'card';
  companyId: string;
  onAddContact: () => void;
  refreshContacts: () => void;
}

export const ContactsContent = ({ 
  contacts, 
  loading, 
  viewMode,
  companyId,
  onAddContact,
  refreshContacts
}: ContactsContentProps) => {
  const [viewingContact, setViewingContact] = useState<Contact | null>(null);
  const [editingContact, setEditingContact] = useState<Contact | null>(null);
  
  // Persist view mode choice
  useEffect(() => {
    saveViewMode('company-contacts', viewMode as any);
  }, [viewMode]);
  
  const handleViewContact = (contact: Contact) => {
    setViewingContact(contact);
  };
  
  const handleEditContact = (contact: Contact) => {
    setViewingContact(null);
    setEditingContact(contact);
  };
  
  const handleContactSaved = () => {
    setEditingContact(null);
    refreshContacts();
  };

  return (
    <>
      <ContactsList 
        contacts={contacts}
        loading={loading}
        viewMode={viewMode}
        companyId={companyId}
        onAddContact={onAddContact}
        onViewContact={handleViewContact}
        onEditContact={handleEditContact}
      />
      
      <ContactViewModal 
        isOpen={viewingContact !== null}
        onClose={() => setViewingContact(null)}
        contact={viewingContact}
        onEdit={handleEditContact}
        companyId={companyId}
      />
      
      <ContactEditModal 
        isOpen={editingContact !== null}
        onClose={() => setEditingContact(null)}
        contact={editingContact}
        companyId={companyId}
        onSave={handleContactSaved}
      />
    </>
  );
};
